import Grid from "@mui/material/Grid2";
import React, { useEffect, useState } from "react";
import { APP_ICONS } from "../../assets";
import DashboardCard from "../../components/cards/DashboardCard";
import CustomBar from "../../components/customBar";
import Loader from "../../components/loader";
import NavigationDrawer from "../../components/navigationDrawer";
import { fetchWithdrawalHistory } from "../../services/Paymen";
import { constants } from "../../theme/Variables";
import WithDrawalsRequest from "./WithDrawalsRequest";

let cartData = [
  {
    icon: APP_ICONS.cashBgIcon,
    value: "000,000",
    title: "Total Balance",
    percentage: "00.00",
  },
  {
    icon: APP_ICONS.homeBgIcon,
    value: "000,000",
    title: "Vendors Balance",
    percentage: "00.00",
  },
  {
    icon: APP_ICONS.balanceBgIcon,
    value: "000,000",
    title: "BB Life Balance",
    percentage: "00.00",
  },
];

const WithDrawalsPage = () => {
  const [withdrawalHistory, setWithdrawalHistory] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [monthTotal, setMonthTotal] = useState([]);

  useEffect(() => {
    handleFetchWithDrawalHistory();
  }, []);

  const handleFetchWithDrawalHistory = async () => {
    try {
      setIsLoading(true);
      const response = await fetchWithdrawalHistory();
      let data = response?.data?.data;

      setIsLoading(false);
      if (response.status === 200 || response.status === 201) {
        setWithdrawalHistory(data?.history || []);
        setMonthTotal(data?.currentMonthCount || 0);
      } else {
        handleOpenSnackBar("error", response.data.message);
      }
    } catch (error) {
      setIsLoading(false);
      handleOpenSnackBar("error", error?.message || "An error occurred");
    }
  };
  const handleOpenSnackBar = (type, message) => {
    constants.snackRef.isOpenSnack({ snackType: type, snackMessage: message });
  };
  return (
    <NavigationDrawer>
      {/* Mini Header */}
      <CustomBar title={"WITHDRAWALS"} />

      {/* Dashboard Cards */}
      {/* <Grid container spacing={2} mb={3}>
        {cartData.map((item, index) => {
          return (
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <DashboardCard key={index} cardData={item} cardIndex={index} />
            </Grid>
          );
        })}
      </Grid> */}

      {/* WithDrawalsRequest */}
      <WithDrawalsRequest data={withdrawalHistory} monthTotal={monthTotal} />
      <Loader isLoading={isLoading} />
    </NavigationDrawer>
  );
};

export default WithDrawalsPage;
